import * as React from 'react';
import { BaseDateInput } from './BaseDateInput';
import classNames from 'classnames';
import * as Classes from '../common/classes';
import { lastDayOfMonth } from 'date-fns';

export type DateInputProps = Omit<
  React.ComponentProps<typeof BaseDateInput>,
  'showTime' | 'monthPicker' | 'convertValue' | 'showDayOfWeek'
> & {
  endOfMonth?: boolean;
};

export const MonthInput: React.FC<DateInputProps> = ({
  className,
  endOfMonth,
  dataTest,
  autoFocus,
  ...other
}) => {
  const fixDate = (value?: Date) => {
    if (value) {
      if (endOfMonth) {
        value = lastDayOfMonth(value)
      } else {
        value.setDate(1);
      }
      return value;
    } else {
      return value;
    }
  };

  return (
    <BaseDateInput
      dataTest={dataTest}
      convertValue={fixDate}
      className={classNames(
        className,
        Classes.DATE_INPUT,
        Classes.STRING_DATE_INPUT
      )}
      {...other}
      showTime={false}
      monthPicker
      autoFocus={autoFocus}
    />
  );
};
